import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { CityForSelectType } from '#home/types';
import { CityChooser } from '#components/city-chooser/CityChooser';
import cityChooserCss from '#srcCssModules/city-chooser/city-chooser.module.scss';

type PropsType = {
  selectedCity: CityForSelectType|null;
  setSelectedCity: (selectedCity: CityForSelectType) => void
};

const CardLocationCityChooser: FC<PropsType> = ({
  selectedCity,
  setSelectedCity,
}) => (
  <CityChooser
    id="react-select-choose-city"
    styles={{
      control: (base) => ({
        ...base,
        borderWidth: 0,
        boxShadow: 'none',
      }),
      container: (base) => ({
        ...base,
        flexGrow: 1,
      }),
    }}
    placeholder={(
      <div className={cityChooserCss.cityChooser__placeholder}>
        <FormattedMessage defaultMessage="your city" />
      </div>
    )}
    defaultValue={selectedCity}
    onChange={setSelectedCity}
  />
);

export { CardLocationCityChooser };
